// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { Link } from 'src/modules/link/jsx/component.jsx';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";


// Stateful components

export class ResearchLinks extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};
    }


    //
    // Functions
    //

    getLinks() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var current_page = portal_context['current_page'];
        var page_data = helpers.getPageBySlug(current_page);

        if (page_data) {
            var page_content = page_data['content'];

            if (typeof(page_content) !== 'undefined') {
                var i_want_to_links = page_content['i_want_to_links'];

                if(typeof(i_want_to_links) !== 'undefined'){
                    return i_want_to_links;
                }
            }
        }

        return null;
    }

    checkForDynamicLinks(links_list) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        links_list.forEach(function(link, link_index) {
            if(typeof(link['link_asset_id']) !== 'undefined') {
                link['link_url'] = helpers.getDynamicLinkUrlById(link['link_asset_id']);
            } else {
                link['link_url'] = helpers.getDynamicLinkURL(link['link_url']);
            }
        });

        return links_list;
    }


    //
    // Render
    //

    renderLinks() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];

        var links = this_component.getLinks();

        if (links) {
            var links_list = links['list'];
            var filtered_links = [];
            
            if (links_list) {
                filtered_links = sq_personalise.fn.filterItems(links_list, user_personalisation['attributes']);
            }

            if (filtered_links.length > 0) {
                filtered_links = this_component.checkForDynamicLinks(filtered_links);

                return filtered_links.map(function(link, link_index){
                    var item_key = link_index;
                    var link_data = {
                        'url': link['link_url'],
                        'class': 'i-want-links__link',
                        'label': link['name']
                    };

                    return (
                        <li key={item_key} className="i-want-links__item">
                            <Link data={link_data} />
                        </li>
                    )
                });
            }
        }
        
        return null;
    }

    render() {
        var this_component = this;
        var i_want_to_links = this_component.renderLinks();

        if(i_want_to_links) {
            return (
                <div className="i-want-links__wrapper">
                    <h2 className="link-block__title">Quick access</h2>
                    <ul className="i-want-links__list">
                        {i_want_to_links}
                    </ul>
                </div>  
            );
        }

        return null;
    }

};

ResearchLinks.contextType = PortalContext;
